/**
 * What a registered interaction produced (RF-38).
 *
 * Mirrors `TaskOutcomeEnum` in `trendmulti-apps/libs/trendmulti-core/src/enum/` —
 * the value is posted to `POST /api/task/:idTask/outcome`, which validates it
 * against the backend enum, so the two must stay identical string for string.
 */
export enum TaskOutcomeEnum {
  HELD = "HELD",
  NO_ANSWER = "NO_ANSWER",
  RESCHEDULED = "RESCHEDULED",
  PROPOSAL_SENT = "PROPOSAL_SENT",
  NOT_INTERESTED = "NOT_INTERESTED",
  OTHER = "OTHER",
}
